module.exports = __webpack_public_path__ + "static/media/PayementSBSScreen.9e3958be.png";